import axios from 'axios';
import Cookies from 'js-cookie';
import { useReducer } from 'react';
import { apiReducer } from '../../reducers/apiReducer';
const useDeleteApi = (initialData) => {
  const [state, dispatch] = useReducer(apiReducer, {
    data: initialData,
    isLoading: false,
    isError: false,
  });

  const deleteData = async (url) => {

    dispatch({ type: 'DELETE_INIT' });
    try {
      const csrfToken = Cookies.get('csrftoken');
      const response = await axios.delete(url, {
        headers: {
          'X-CSRFToken': csrfToken,
        },
        withCredentials:true,
      });
      dispatch({ type: 'DELETE_SUCCESS', payload: response.data });
      return { success: true, data: response.data };
    } catch (error) {
      dispatch({ type: 'DELETE_FAILURE' });
      // l'appelant peut dire pourquoi le serveur a refusé, au lieu de faire comme si c'était supprimé
      return { success: false, error };
    }
  };

  return { ...state, deleteData };
};

export default useDeleteApi;